<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Content from '@/services/Content'
    import modalViewPostDetails from "@/components/modals/news/modalViewPostDetails";
    import countTo from "vue-count-to";

    export default {
        components: { Layout, PageHeader, modalViewPostDetails, countTo },
        page: {
            title: "Social Upload",
            meta: [
                {
                    name: "description",
                    content: appConfig.description,
                },
            ],
        },
        data() {
            return {
                title: "Social Upload",
                items: [
                    {
                        text: "Content",
                    },
                    {
                        text: "Social Upload",
                        active: true,
                        href: "/content/social_upload",
                    },
                ],
                // Profile / connection state
                username: process.env.VUE_APP_TENANT || "",
                profile: {},
                loadingProfile: false,
                profileError: null,
                isConnecting: false,
                // Analytics metric boxes
                impressions: null,
                impressionsRange: null,
                loadingImpressions: false,
                impressionsError: null,
                // Per-platform analytics (reach / followers / engagements).
                // Starts true: these boxes wait on the connected-account list, so
                // show the loader from first paint instead of flashing a 0.
                analytics: {},
                loadingAnalytics: true,
                analyticsError: null,
                // Connected social accounts
                socialAccounts: [],
                loadingSocialAccounts: true,
                // Facebook pages
                facebookPages: [],
                loadingFacebookPages: false,
                // LinkedIn pages
                linkedinPages: [],
                loadingLinkedinPages: false,
                // Composer state
                postType: "text",
                postTypes: [
                    { value: "text", label: "Text", icon: "mdi mdi-format-text" },
                    { value: "photos", label: "Photos", icon: "mdi mdi-image-multiple" },
                    { value: "video", label: "Video", icon: "mdi mdi-video" },
                ],
                knownPlatforms: [
                    { key: "instagram", label: "Instagram", icon: "mdi mdi-instagram" },
                    { key: "tiktok", label: "TikTok", icon: "mdi mdi-music-note" },
                    { key: "x", label: "X (Twitter)", icon: "mdi mdi-twitter" },
                    { key: "facebook", label: "Facebook", icon: "mdi mdi-facebook" },
                    { key: "youtube", label: "YouTube", icon: "mdi mdi-youtube" },
                    { key: "linkedin", label: "LinkedIn", icon: "mdi mdi-linkedin" },
                ],
                isPublishing: false,
                composerOpen: false,
                // Post history
                history: [],
                loadingHistory: false,
                selectedHistoryItem: null,
                historyCurrentPage: 1,
                historyPerPage: 10,
                historySearch: "",
                statusFilter: "All",
                statusFilters: ["All", "Published", "Partial", "Scheduled", "Processing", "Failed"],
                historyFields: [
                    { key: "post", label: "Post" },
                    { key: "platforms", label: "Platforms" },
                    { key: "engagement", label: "Engagement" },
                    { key: "created", label: "Date" },
                    { key: "scheduled", label: "Scheduled" },
                    { key: "status", label: "Status" },
                ],
                // File upload UI state
                photoDragOver: false,
                videoDragOver: false,
                photoPreviews: [],
                photoDimensions: [],
                videoPreviewUrl: null,
                videoMeta: null,
                // Per-platform photo requirements (upload-post docs). Only the
                // platforms we offer for photos; constraints apply when selected.
                // ratio = width / height. TikTok photo mode wants portrait (≤ 1:1);
                // upload-post doesn't publish exact numbers, so these are tunable.
                photoPlatformRules: {
                    instagram: {
                        formats: ["image/png", "image/jpeg", "image/gif"],
                        display: "PNG, JPG or GIF",
                    },
                    tiktok: {
                        formats: ["image/jpeg", "image/webp"],
                        minWidth: 360,
                        minHeight: 360,
                        minRatio: 9 / 16, // 0.5625 — not taller than 9:16
                        maxRatio: 1,      // not wider than square (no landscape)
                        display: "JPG, JPEG or WEBP · portrait or square (9:16 to 1:1, no landscape) · min 360×360",
                    },
                    facebook: {
                        formats: ["image/jpeg", "image/png", "image/gif", "image/webp"],
                        display: "JPG, PNG, GIF or WebP",
                    },
                    x: {
                        formats: ["image/jpeg", "image/png", "image/gif", "image/webp"],
                        maxSizeMB: 5,
                        maxCount: 4,
                        display: "JPG, PNG, GIF or WebP · up to 5 MB each · max 4 photos",
                    },
                },
                // Per-platform video requirements (upload-post docs). Constraints
                // apply when the platform is selected; `display` drives the UI note.
                videoPlatformRules: {
                    instagram: {
                        formats: ["video/mp4", "video/quicktime"],
                        maxSizeMB: 300, minDuration: 3, maxDuration: 900,
                        display: "MP4 or MOV · up to 300 MB · 3 s–15 min",
                    },
                    tiktok: {
                        formats: ["video/mp4", "video/webm", "video/quicktime"],
                        maxSizeMB: 4096, maxDuration: 600, minWidth: 360, minHeight: 360,
                        display: "MP4, WebM or MOV · up to 4 GB · ≤ 10 min · min 360×360",
                    },
                    facebook: {
                        formats: ["video/mp4", "video/quicktime"],
                        minDuration: 3, maxDuration: 90,
                        display: "MP4 or MOV · 3–90 s (posted as a Reel)",
                    },
                    x: {
                        formats: ["video/mp4"],
                        maxSizeMB: 1024, minDuration: 0.5, maxDuration: 14400, minRatio: 1 / 3, maxRatio: 3,
                        display: "MP4 · up to 1 GB · 0.5 s–4 h · aspect 1:3 to 3:1",
                    },
                    youtube: {
                        display: "Most video formats · up to 256 GB",
                    },
                },
                form: {
                    platforms: [],
                    facebook_page_id: "",
                    target_linkedin_page_id: "",
                    title: "",
                    description: "",
                    link_url: "",
                    scheduled_date: "",
                    photos: [],
                    video: null,
                },
              logo_image:"https://stadiaconnect-cdn.s3.eu-west-1.amazonaws.com/psv/img/sponsor/azerion_emblem.png",
            };
        },
        computed: {
            // Aggregated metric-box values, summed across the connected platforms
            // returned by the analytics endpoint.
            totalReach() {
                return Object.values(this.analytics)
                    .reduce((sum, p) => sum + (Number(p && p.reach) || 0), 0);
            },
            gainedFollowers() {
                return Object.values(this.analytics)
                    .reduce((sum, p) => sum + (Number(p && p.followers) || 0), 0);
            },
            totalEngagements() {
                return Object.values(this.analytics).reduce((sum, p) => {
                    if (!p) return sum;
                    return sum
                        + (Number(p.likes) || 0)
                        + (Number(p.comments) || 0)
                        + (Number(p.shares) || 0)
                        + (Number(p.saves) || 0);
                }, 0);
            },
            availablePlatforms() {
                const byPlatform = {};
                (this.socialAccounts || []).forEach(a => { byPlatform[a.platform] = a; });
                const list = this.knownPlatforms.map(p => ({
                    ...p,
                    connected: !!byPlatform[p.key],
                    account: byPlatform[p.key] || null,
                }));
                // Include any connected platform we don't know about.
                Object.keys(byPlatform).forEach(key => {
                    if (!this.knownPlatforms.some(p => p.key === key)) {
                        list.push({
                            key,
                            label: key.charAt(0).toUpperCase() + key.slice(1),
                            icon: "mdi mdi-share-variant",
                            connected: true,
                            account: byPlatform[key],
                        });
                    }
                });
                // platforms hidden for now
                const hidden = ["linkedin"];
                return list.filter(p => !hidden.includes(p.key));
            },
            // upload-post's connected accounts (source of truth), keyed by platform.
            uploadPostAccounts() {
                return (this.profile && this.profile.social_accounts) || {};
            },
            // Our own stored accounts, keyed by platform for lookup.
            dbAccountsByPlatform() {
                const map = {};
                (this.socialAccounts || []).forEach(a => { if (a && a.platform) map[a.platform] = a; });
                return map;
            },
            // Cross-check what we have in our DB against what upload-post reports.
            // upload-post is the source of truth; any drift is surfaced as an error.
            accountMismatches() {
                // Wait until both sources have resolved and the profile is usable.
                if (this.loadingProfile || this.loadingSocialAccounts) return [];
                if (this.profileError || !this.profile || !this.profile.username) return [];
                const up = this.uploadPostAccounts;
                const db = this.dbAccountsByPlatform;
                const platforms = Array.from(new Set([...Object.keys(up), ...Object.keys(db)]));
                const issues = [];
                platforms.forEach(key => {
                    const u = up[key];
                    const d = db[key];
                    const label = this.platformLabel(key);
                    if (u && !d) {
                        issues.push(`${label}: connected in Upload-Post (@${u.handle || u.display_name || "—"}) but missing from our records.`);
                    } else if (!u && d) {
                        issues.push(`${label}: in our records (@${d.handle || d.display_name || "—"}) but not connected in Upload-Post.`);
                    } else if (u && d) {
                        const uh = (u.handle || "").trim();
                        const dh = (d.handle || "").trim();
                        const un = (u.display_name || "").trim();
                        const dn = (d.display_name || "").trim();
                        if (uh !== dh || un !== dn) {
                            issues.push(`${label}: account details differ (Upload-Post: ${un || "—"} @${uh || "—"}, ours: ${dn || "—"} @${dh || "—"}).`);
                        }
                    }
                });
                return issues;
            },
            visiblePlatforms() {
                // platforms that each post type can't target
                const excluded = {
                    text: ["instagram", "tiktok", "youtube"],
                    photos: ["youtube"],
                    video: [],
                };
                const hidden = excluded[this.postType] || [];
                return this.availablePlatforms.filter(p => !hidden.includes(p.key));
            },
            connectedPlatforms() {
                return this.visiblePlatforms.filter(p => p.connected);
            },
            needsFacebookPage() {
                return this.form.platforms.includes("facebook");
            },
            needsLinkedinPage() {
                return this.form.platforms.includes("linkedin");
            },
            // Per-platform requirement lines shown to the user for photo posts.
            photoRequirements() {
                const labels = { instagram: "Instagram", tiktok: "TikTok", x: "X (Twitter)", facebook: "Facebook" };
                return this.form.platforms
                    .filter(p => this.photoPlatformRules[p] && this.photoPlatformRules[p].display)
                    .map(p => ({ platform: p, label: labels[p] || p, display: this.photoPlatformRules[p].display }));
            },
            showDescription() {
                // the platforms that actually read the description differ per post type
                if (this.postType === "text") return false;
                const platformsUsingDescription = this.postType === "video"
                    ? ["youtube", "facebook", "linkedin"]
                    : ["tiktok", "linkedin"]; // photos
                return this.form.platforms.some(p => platformsUsingDescription.includes(p));
            },
            descriptionHint() {
                if (this.postType === "video") {
                    return "Optional extended text used only on LinkedIn commentary, Facebook descriptions, YouTube descriptions, and Pinterest notes. Ignored elsewhere.";
                }
                if (this.postType === "photos") {
                    return "Optional extended text used on TikTok photo descriptions, LinkedIn commentary, Pinterest notes, and Reddit bodies. On Facebook the photo caption comes from the Content field, not here. Ignored elsewhere.";
                }
                return "";
            },
            // Photo constraints derived from the currently selected platforms.
            photoConstraints() {
                const selected = this.form.platforms.filter(p => this.photoPlatformRules[p]);
                let allowedTypes = null; // null = no restriction
                let maxSizeMB = Infinity;
                let maxCount = Infinity;
                let minWidth = 0;
                let minHeight = 0;
                let minRatio = 0;
                let maxRatio = Infinity;
                selected.forEach(key => {
                    const rule = this.photoPlatformRules[key];
                    if (rule.formats) {
                        allowedTypes = allowedTypes === null
                            ? rule.formats.slice()
                            : allowedTypes.filter(f => rule.formats.includes(f));
                    }
                    if (rule.maxSizeMB) maxSizeMB = Math.min(maxSizeMB, rule.maxSizeMB);
                    if (rule.maxCount) maxCount = Math.min(maxCount, rule.maxCount);
                    if (rule.minWidth) minWidth = Math.max(minWidth, rule.minWidth);
                    if (rule.minHeight) minHeight = Math.max(minHeight, rule.minHeight);
                    if (rule.minRatio) minRatio = Math.max(minRatio, rule.minRatio);
                    if (rule.maxRatio) maxRatio = Math.min(maxRatio, rule.maxRatio);
                });
                return { allowedTypes, maxSizeMB, maxCount, minWidth, minHeight, minRatio, maxRatio };
            },
            allowedFormatsLabel() {
                const types = this.photoConstraints.allowedTypes;
                if (!types) return "";
                const map = { "image/jpeg": "JPG", "image/png": "PNG", "image/gif": "GIF", "image/webp": "WEBP" };
                return types.map(t => map[t] || t).join(", ");
            },
            photoAccept() {
                const types = this.photoConstraints.allowedTypes;
                return (types && types.length) ? types.join(",") : "image/*";
            },
            photoHint() {
                const c = this.photoConstraints;
                const parts = [this.allowedFormatsLabel || "PNG, JPG, GIF"];
                if (Number.isFinite(c.maxSizeMB)) parts.push(`max ${c.maxSizeMB} MB each`);
                if (Number.isFinite(c.maxCount)) parts.push(`up to ${c.maxCount} photos`);
                return parts.join(" · ");
            },
            // Video constraints derived from the currently selected platforms.
            videoConstraints() {
                const selected = this.form.platforms.filter(p => this.videoPlatformRules[p]);
                let allowedTypes = null;
                let maxSizeMB = Infinity;
                let minDuration = 0;
                let maxDuration = Infinity;
                let minWidth = 0;
                let minHeight = 0;
                let minRatio = 0;
                let maxRatio = Infinity;
                selected.forEach(key => {
                    const rule = this.videoPlatformRules[key];
                    if (rule.formats) {
                        allowedTypes = allowedTypes === null
                            ? rule.formats.slice()
                            : allowedTypes.filter(f => rule.formats.includes(f));
                    }
                    if (rule.maxSizeMB) maxSizeMB = Math.min(maxSizeMB, rule.maxSizeMB);
                    if (rule.minDuration) minDuration = Math.max(minDuration, rule.minDuration);
                    if (rule.maxDuration) maxDuration = Math.min(maxDuration, rule.maxDuration);
                    if (rule.minWidth) minWidth = Math.max(minWidth, rule.minWidth);
                    if (rule.minHeight) minHeight = Math.max(minHeight, rule.minHeight);
                    if (rule.minRatio) minRatio = Math.max(minRatio, rule.minRatio);
                    if (rule.maxRatio) maxRatio = Math.min(maxRatio, rule.maxRatio);
                });
                return { allowedTypes, maxSizeMB, minDuration, maxDuration, minWidth, minHeight, minRatio, maxRatio };
            },
            videoFormatsLabel() {
                const types = this.videoConstraints.allowedTypes;
                if (!types) return "";
                const map = { "video/mp4": "MP4", "video/quicktime": "MOV", "video/webm": "WebM" };
                return types.map(t => map[t] || t).join(", ");
            },
            videoAccept() {
                const types = this.videoConstraints.allowedTypes;
                return (types && types.length) ? types.join(",") : "video/*";
            },
            videoHint() {
                const c = this.videoConstraints;
                const parts = [this.videoFormatsLabel || "MP4, MOV"];
                if (Number.isFinite(c.maxSizeMB)) parts.push(`max ${this.sizeLabel(c.maxSizeMB)}`);
                return parts.join(" · ");
            },
            // Per-platform requirement lines shown to the user for video posts.
            videoRequirements() {
                const labels = { instagram: "Instagram", tiktok: "TikTok", x: "X (Twitter)", facebook: "Facebook", youtube: "YouTube" };
                return this.form.platforms
                    .filter(p => this.videoPlatformRules[p] && this.videoPlatformRules[p].display)
                    .map(p => ({ platform: p, label: labels[p] || p, display: this.videoPlatformRules[p].display }));
            },
            // Post history filtered by the search box and the status tabs.
            filteredHistory() {
                const q = this.historySearch.trim().toLowerCase();
                return this.history.filter(item => {
                    if (this.statusFilter !== "All" && this.statusMeta(item).label !== this.statusFilter) {
                        return false;
                    }
                    if (!q) return true;
                    const text = `${item.content || ""} ${item.description || ""}`.toLowerCase();
                    return text.includes(q);
                });
            },
        },
        watch: {
            "form.platforms"(val) {
                if (val.includes("facebook") && !this.facebookPages.length) {
                    this.loadFacebookPages();
                }
                if (val.includes("linkedin") && !this.linkedinPages.length) {
                    this.loadLinkedinPages();
                }
            },
            postType() {
                // drop any selected platforms the current post type doesn't support
                const allowed = this.visiblePlatforms.map(p => p.key);
                this.form.platforms = this.form.platforms.filter(p => allowed.includes(p));
            },
        },
        async created() {
            // returning from the connect/management screen: persist the accounts
            if (this.$route.query.upload_post) {
                await this.saveSocialAccounts();
                // drop the marker so a refresh doesn't re-trigger the save
                const query = { ...this.$route.query };
                delete query.upload_post;
                this.$router.replace({ query }).catch(() => {});
            }
            // Fire the independent loads in parallel so each shows its own
            // loader immediately, instead of queuing behind the profile fetch.
            this.loadProfile();
            // analytics needs the connected-platform list, so run it once accounts load
            this.loadSocialAccounts().then(() => this.loadAnalytics());
            this.loadHistory();
            this.loadImpressions();
        },
        methods: {
            async loadImpressions() {
                this.loadingImpressions = true;
                this.impressionsError = null;
                try {
                    const response = await Content.getUploadPostImpressions();
                    const data = response.data.data || {};
                    this.impressions = Number(data.total_impressions) || 0;
                    this.impressionsRange = (data.start_date && data.end_date)
                        ? `${data.start_date} – ${data.end_date}`
                        : null;
                } catch (error) {
                    this.impressions = null;
                    this.impressionsError = this.parseError(error);
                } finally {
                    this.loadingImpressions = false;
                }
            },

            async loadAnalytics() {
                // call with only our connected platforms, comma-separated
                const platforms = (this.socialAccounts || [])
                    .map(a => a.platform)
                    .filter(Boolean);
                if (!platforms.length) {
                    this.analytics = {};
                    this.loadingAnalytics = false;
                    return;
                }
                this.loadingAnalytics = true;
                this.analyticsError = null;
                try {
                    // facebook analytics needs our page id as an extra parameter
                    let pageId = "";
                    if (platforms.includes("facebook")) {
                        if (!this.facebookPages.length) {
                            await this.loadFacebookPages();
                        }
                        pageId = this.facebookPages.length ? this.facebookPages[0].id : "";
                    }
                    const response = await Content.getUploadPostAnalytics(platforms.join(","), pageId);
                    this.analytics = response.data.data || {};
                } catch (error) {
                    this.analytics = {};
                    this.analyticsError = this.parseError(error);
                } finally {
                    this.loadingAnalytics = false;
                }
            },

            async loadSocialAccounts() {
                this.loadingSocialAccounts = true;
                try {
                    const response = await Content.getSocialAccounts();
                    this.socialAccounts = response.data.data || [];
                } catch (error) {
                    this.socialAccounts = [];
                    this.failedmsg("Connected accounts", this.parseError(error));
                } finally {
                    this.loadingSocialAccounts = false;
                }
            },

            async saveSocialAccounts() {
                try {
                    await Content.saveSocialAccounts();
                } catch (error) {
                    this.failedmsg("Save accounts", this.parseError(error));
                }
            },

            parseError(error) {
                const e = error && error.response && error.response.data ? error.response.data.error : null;
                if (Array.isArray(e)) {
                    return e.join("<br>");
                }
                return e || "Something went wrong. Please try again.";
            },

            async loadProfile() {
                this.loadingProfile = true;
                this.profileError = null;
                try {
                    const response = await Content.getUploadPostProfile(this.username);
                    // The upload-post profile endpoint returns data as an array of
                    // one profile object; normalize to that single object.
                    const data = response.data.data;
                    this.profile = Array.isArray(data) ? (data[0] || {}) : (data || {});
                } catch (error) {
                    this.profile = {};
                    this.profileError = this.parseError(error);
                } finally {
                    this.loadingProfile = false;
                }
            },

            async connectAccounts() {
                this.isConnecting = true;
                try {
                    // bring the user back to this page with a marker so we can
                    // persist the connected accounts on return
                    const redirectUrl = new URL(window.location.href);
                    redirectUrl.searchParams.set("upload_post", "1");
                    const response = await Content.uploadPostConnectSocials({
                        username: this.username,
                        redirect_url: redirectUrl.href,
                        redirect_button_text: "Go Back",
                        language: "nl",
                        logo_image: this.logo_image,
                        platforms: this.knownPlatforms.map(p => p.key),
                    });
                    const url = response.data.data ? response.data.data.access_url : null;
                    if (url) {
                        // navigate the current tab (avoids popup blockers); redirect_url returns the user here
                        window.location.href = url;
                    } else {
                        this.failedmsg("Connect accounts", "No connection URL was returned.");
                    }
                } catch (error) {
                    this.failedmsg("Connect accounts", this.parseError(error));
                } finally {
                    this.isConnecting = false;
                }
            },

            async loadFacebookPages() {
                this.loadingFacebookPages = true;
                try {
                    const response = await Content.getUploadPostFacebookPages();
                    this.facebookPages = (response.data.data && response.data.data.pages) ? response.data.data.pages : [];
                } catch (error) {
                    this.facebookPages = [];
                    this.failedmsg("Facebook Pages", this.parseError(error));
                } finally {
                    this.loadingFacebookPages = false;
                }
            },

            async loadHistory() {
                this.loadingHistory = true;
                try {
                    const response = await Content.getUploadPostHistory();
                    const items = response.data.data || [];
                    // newest first
                    this.history = items.slice().sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
                } catch (error) {
                    this.history = [];
                    this.failedmsg("Post history", this.parseError(error));
                } finally {
                    this.loadingHistory = false;
                }
            },

            // Total engagement for a post row, taken straight from the history
            // payload (post_metrics_total.total_engagement) — no per-post fetch.
            postEngagement(item) {
                const total = item && item.post_metrics_total;
                return (total && Number(total.total_engagement)) || 0;
            },
            // Per-post analytics fetch — removed for now. The history endpoint
            // returns post_metrics_total.total_engagement per row, so we no longer
            // call getUploadPostSinglePostAnalytics for every item. Kept here
            // (and in the service) in case we need finer per-platform metrics later.
            // loadAllPostMetrics() {
            //     (this.history || []).forEach(item => this.loadPostMetrics(item));
            // },
            // async loadPostMetrics(item) {
            //     const id = item && item.request_id;
            //     if (!id) return;
            //     this.$set(this.postMetrics, id, { loading: true, error: null, engagement: 0 });
            //     try {
            //         const response = await Content.getUploadPostSinglePostAnalytics(id);
            //         const platforms = (response.data.data && response.data.data.platforms) || {};
            //         // post_metrics fields differ per platform, so sum every interaction
            //         // field and skip the impression/view counters (not engagement).
            //         const nonEngagement = ["impressions", "views", "reach"];
            //         let engagement = 0;
            //         Object.values(platforms).forEach(p => {
            //             const m = (p && p.post_metrics) || {};
            //             Object.keys(m).forEach(key => {
            //                 if (nonEngagement.includes(key)) return;
            //                 engagement += Number(m[key]) || 0;
            //             });
            //         });
            //         this.$set(this.postMetrics, id, { loading: false, error: null, engagement });
            //     } catch (error) {
            //         this.$set(this.postMetrics, id, { loading: false, error: this.parseError(error), engagement: 0 });
            //     }
            // },

            // The history endpoint returns two meta_data shapes: an older one where
            // results is a platform-keyed object, and a newer one where results is
            // an array of per-platform objects. Normalize both to one list.
            historyResults(item) {
                const results = item && item.meta_data ? item.meta_data.results : null;
                if (Array.isArray(results)) {
                    return results.map(r => ({
                        platform: r.platform,
                        url: r.post_url,
                        success: r.success,
                        status: r.status ? r.status : (r.success ? "completed" : "failed"),
                        error: r.error_message,
                    }));
                }
                if (results && typeof results === "object") {
                    return Object.keys(results).map(platform => ({
                        platform,
                        url: results[platform].url,
                        success: results[platform].success,
                        status: results[platform].status || (results[platform].success ? "completed" : "failed"),
                        error: results[platform].error,
                    }));
                }
                return [];
            },
            historyStatus(item) {
                const meta = item && item.meta_data ? item.meta_data : {};
                return meta.status || (meta.success ? "completed" : "");
            },
            statusBadgeClass(status) {
                if (status === "completed") return "bg-success";
                if (status === "failed") return "bg-danger";
                return "bg-secondary";
            },
            platformIcon(platform) {
                const p = this.knownPlatforms.find(k => k.key === platform);
                return p ? p.icon : "mdi mdi-share-variant";
            },
            platformLabel(key) {
                const p = this.knownPlatforms.find(k => k.key === key);
                return p ? p.label : (key.charAt(0).toUpperCase() + key.slice(1));
            },
            // Circular badge initial + brand colour per platform.
            platformMeta(key) {
                const map = {
                    instagram: { color: "#E1306C", icon: "mdi mdi-instagram" },
                    tiktok: { color: "#111111", icon: "mdi mdi-music-note" },
                    x: { color: "#1DA1F2", icon: "mdi mdi-twitter" },
                    twitter: { color: "#1DA1F2", icon: "mdi mdi-twitter" },
                    facebook: { color: "#1877F2", icon: "mdi mdi-facebook" },
                    youtube: { color: "#FF0000", icon: "mdi mdi-youtube" },
                    linkedin: { color: "#0A66C2", icon: "mdi mdi-linkedin" },
                };
                return map[key] || { color: "#6c757d", icon: "mdi mdi-share-variant" };
            },
            // Display label + colour variant for the status pill.
            statusMeta(item) {
                // A post hitting several platforms can partly succeed: some
                // published, some failed (e.g. TikTok rejects the media but
                // Facebook publishes). Surface that as "Partial" rather than a
                // flat Published/Failed.
                const results = this.historyResults(item);
                const succeeded = results.filter(r => r.status === "completed").length;
                const failed = results.filter(r => r.status === "failed").length;
                if (succeeded > 0 && failed > 0) {
                    return { label: "Partial", variant: "partial" };
                }
                const s = this.historyStatus(item);
                if (s === "completed") return { label: "Published", variant: "success" };
                if (s === "queued") return { label: "Scheduled", variant: "info" };
                if (s === "processing" || s === "pending" || s === "in_progress") return { label: "Processing", variant: "warning" };
                if (s === "failed") return { label: "Failed", variant: "danger" };
                if (!s) return { label: "—", variant: "secondary" };
                return { label: s.charAt(0).toUpperCase() + s.slice(1), variant: "secondary" };
            },
            // Date/time parts for a date string ("YYYY-MM-DD HH:MM:SS").
            dateParts(str) {
                if (!str) return { date: "", time: "" };
                const d = new Date(str.replace(" ", "T"));
                if (isNaN(d.getTime())) return { date: str, time: "" };
                return {
                    date: d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }),
                    time: d.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: false }),
                };
            },
            viewPostDetails(item) {
                this.selectedHistoryItem = item;
                this.$bvModal.show("view_post_details");
            },

            async loadLinkedinPages() {
                this.loadingLinkedinPages = true;
                try {
                    const response = await Content.getUploadPostLinkedinPages();
                    this.linkedinPages = (response.data.data && response.data.data.pages) ? response.data.data.pages : [];
                } catch (error) {
                    this.linkedinPages = [];
                    this.failedmsg("LinkedIn Pages", this.parseError(error));
                } finally {
                    this.loadingLinkedinPages = false;
                }
            },

            buildFormData() {
                const fd = new FormData();
                // platforms are sent as a JSON-encoded string in platform[0]
                fd.append("platform[0]", JSON.stringify(this.form.platforms));
                if (this.form.title) fd.append("title", this.form.title);
                // optional extended text, only when the description field is shown
                if (this.showDescription && this.form.description) fd.append("description", this.form.description);
                if (this.needsFacebookPage && this.form.facebook_page_id) {
                    fd.append("facebook_page_id", this.form.facebook_page_id);
                }
                // optional: post to a LinkedIn organization page (else the user's profile)
                if (this.needsLinkedinPage && this.form.target_linkedin_page_id) {
                    fd.append("target_linkedin_page_id", this.form.target_linkedin_page_id);
                }
                if (this.form.scheduled_date) {
                    fd.append("scheduled_date", new Date(this.form.scheduled_date).toISOString());
                }
                // fd.append('async_upload',true);
                return fd;
            },

            async publish() {
                // Validation
                if (!this.form.platforms.length) {
                    this.failedmsg("Select a platform", "Choose at least one connected platform to publish to.");
                    return;
                }
                if (this.needsFacebookPage && !this.form.facebook_page_id) {
                    this.failedmsg("Facebook Page required", "Select a Facebook Page to publish to Facebook.");
                    return;
                }
                if (this.postType === "text" && !this.form.title) {
                    this.failedmsg("Text required", "Enter the post text / caption.");
                    return;
                }
                if (this.postType === "photos" && (!this.form.photos || !this.form.photos.length)) {
                    this.failedmsg("Photos required", "Add at least one photo to publish.");
                    return;
                }
                if (this.postType === "photos" && !this.validatePhotos()) {
                    return;
                }
                if (this.postType === "video" && !this.form.video) {
                    this.failedmsg("Video required", "Add a video file to publish.");
                    return;
                }
                if (this.postType === "video" && !this.validateVideo()) {
                    return;
                }

                this.isPublishing = true;
                try {
                    let response;
                    if (this.postType === "text") {
                        const fd = this.buildFormData();
                        if (this.form.link_url) fd.append("link_url", this.form.link_url);
                        response = await Content.uploadPostUploadText(fd);
                    } else if (this.postType === "photos") {
                        const fd = this.buildFormData();
                        Array.from(this.form.photos).forEach(file => fd.append("photos[]", file));
                        response = await Content.uploadPostUploadPhotos(fd);
                    } else {
                        const fd = this.buildFormData();
                        fd.append("video", this.form.video);
                        response = await Content.uploadPostUploadVideo(fd);
                    }

                    if (response && response.data && response.data.data) {
                        this.successmsg("Post submitted", "Your post has been sent to the selected platforms.");
                        this.resetForm();
                        this.loadHistory();
                    } else {
                        this.failedmsg("Publish failed", "Unexpected response from the server.");
                    }
                } catch (error) {
                    this.failedmsg("Publish failed", this.parseError(error));
                } finally {
                    this.isPublishing = false;
                }
            },

            // ----- File upload helpers -----
            triggerInput(ref) {
                this.$refs[ref].click();
            },

            readImageSize(url) {
                return new Promise(resolve => {
                    const img = new Image();
                    img.onload = () => resolve({ width: img.naturalWidth, height: img.naturalHeight });
                    img.onerror = () => resolve({ width: 0, height: 0 });
                    img.src = url;
                });
            },
            // Returns a reason string when the dimensions break a constraint, else "".
            checkPhotoDimensions(dims, c) {
                const { width, height } = dims;
                if (!width || !height) return ""; // couldn't read — don't block
                if (c.minWidth && width < c.minWidth) {
                    return `image must be at least ${c.minWidth}px wide (is ${width}px)`;
                }
                if (c.minHeight && height < c.minHeight) {
                    return `image must be at least ${c.minHeight}px tall (is ${height}px)`;
                }
                const ratio = width / height;
                if (c.minRatio && ratio < c.minRatio - 0.01) {
                    return `aspect ratio ${ratio.toFixed(2)} is too tall for the selected platforms`;
                }
                if (c.maxRatio && Number.isFinite(c.maxRatio) && ratio > c.maxRatio + 0.01) {
                    return `aspect ratio ${ratio.toFixed(2)} is too wide for the selected platforms`;
                }
                return "";
            },
            async addPhotos(fileList) {
                const c = this.photoConstraints;
                const files = Array.from(fileList).filter(file => file.type.startsWith("image/"));
                for (const file of files) {
                    if (c.allowedTypes && !c.allowedTypes.includes(file.type)) {
                        this.failedmsg("Unsupported format", `${file.name} isn't accepted by the selected platforms. Allowed: ${this.allowedFormatsLabel}.`);
                        continue;
                    }
                    if (file.size > c.maxSizeMB * 1024 * 1024) {
                        this.failedmsg("Photo too large", `${file.name} is ${this.formatBytes(file.size)}. Max ${c.maxSizeMB} MB each for the selected platforms.`);
                        continue;
                    }
                    if (this.form.photos.length >= c.maxCount) {
                        this.failedmsg("Too many photos", `The selected platforms allow at most ${c.maxCount} photos.`);
                        break;
                    }
                    const url = URL.createObjectURL(file);
                    const dims = await this.readImageSize(url);
                    const reason = this.checkPhotoDimensions(dims, c);
                    if (reason) {
                        URL.revokeObjectURL(url);
                        this.failedmsg("Unsupported image", `${file.name}: ${reason}.`);
                        continue;
                    }
                    this.form.photos.push(file);
                    this.photoPreviews.push(url);
                    this.photoDimensions.push(dims);
                }
            },
            // Re-check photos at publish time, since the platform selection (and
            // therefore the limits) can change after photos were added.
            validatePhotos() {
                const c = this.photoConstraints;
                if (this.form.photos.length > c.maxCount) {
                    this.failedmsg("Too many photos", `The selected platforms allow at most ${c.maxCount} photos.`);
                    return false;
                }
                for (let i = 0; i < this.form.photos.length; i++) {
                    const file = this.form.photos[i];
                    if (c.allowedTypes && !c.allowedTypes.includes(file.type)) {
                        this.failedmsg("Unsupported format", `${file.name} isn't accepted by the selected platforms. Allowed: ${this.allowedFormatsLabel}.`);
                        return false;
                    }
                    if (file.size > c.maxSizeMB * 1024 * 1024) {
                        this.failedmsg("Photo too large", `${file.name} exceeds the ${c.maxSizeMB} MB limit for the selected platforms.`);
                        return false;
                    }
                    const reason = this.checkPhotoDimensions(this.photoDimensions[i] || {}, c);
                    if (reason) {
                        this.failedmsg("Unsupported image", `${file.name}: ${reason}.`);
                        return false;
                    }
                }
                return true;
            },
            onPhotosSelected(event) {
                this.addPhotos(event.target.files);
                event.target.value = ""; // allow re-selecting the same file
            },
            onPhotosDrop(event) {
                this.photoDragOver = false;
                if (event.dataTransfer && event.dataTransfer.files) {
                    this.addPhotos(event.dataTransfer.files);
                }
            },
            removePhoto(index) {
                URL.revokeObjectURL(this.photoPreviews[index]);
                this.photoPreviews.splice(index, 1);
                this.form.photos.splice(index, 1);
                this.photoDimensions.splice(index, 1);
            },

            sizeLabel(mb) {
                if (!Number.isFinite(mb)) return "";
                return mb >= 1024 ? `${(mb / 1024)} GB` : `${mb} MB`;
            },
            readVideoMeta(url) {
                return new Promise(resolve => {
                    const video = document.createElement("video");
                    video.preload = "metadata";
                    video.onloadedmetadata = () => resolve({
                        duration: video.duration,
                        width: video.videoWidth,
                        height: video.videoHeight,
                    });
                    video.onerror = () => resolve({ duration: 0, width: 0, height: 0 });
                    video.src = url;
                });
            },
            // Returns a reason string when the video breaks a constraint, else "".
            checkVideoMeta(meta, c) {
                if (meta.duration) {
                    if (c.minDuration && meta.duration < c.minDuration) {
                        return `video is too short (${meta.duration.toFixed(1)}s, min ${c.minDuration}s)`;
                    }
                    if (Number.isFinite(c.maxDuration) && meta.duration > c.maxDuration) {
                        return `video is too long (${Math.round(meta.duration)}s, max ${c.maxDuration}s)`;
                    }
                }
                if (meta.width && meta.height) {
                    if (c.minWidth && meta.width < c.minWidth) {
                        return `width must be at least ${c.minWidth}px (is ${meta.width}px)`;
                    }
                    if (c.minHeight && meta.height < c.minHeight) {
                        return `height must be at least ${c.minHeight}px (is ${meta.height}px)`;
                    }
                    const ratio = meta.width / meta.height;
                    if (c.minRatio && ratio < c.minRatio - 0.01) {
                        return `aspect ratio ${ratio.toFixed(2)} is too tall for the selected platforms`;
                    }
                    if (Number.isFinite(c.maxRatio) && ratio > c.maxRatio + 0.01) {
                        return `aspect ratio ${ratio.toFixed(2)} is too wide for the selected platforms`;
                    }
                }
                return "";
            },
            async setVideo(file) {
                if (!file || !file.type.startsWith("video/")) return;
                const c = this.videoConstraints;
                if (c.allowedTypes && !c.allowedTypes.includes(file.type)) {
                    this.failedmsg("Unsupported format", `${file.name} isn't accepted by the selected platforms. Allowed: ${this.videoFormatsLabel}.`);
                    return;
                }
                if (file.size > c.maxSizeMB * 1024 * 1024) {
                    this.failedmsg("Video too large", `${file.name} is ${this.formatBytes(file.size)}. Max ${this.sizeLabel(c.maxSizeMB)} for the selected platforms.`);
                    return;
                }
                const url = URL.createObjectURL(file);
                const meta = await this.readVideoMeta(url);
                const reason = this.checkVideoMeta(meta, c);
                if (reason) {
                    URL.revokeObjectURL(url);
                    this.failedmsg("Unsupported video", `${file.name}: ${reason}.`);
                    return;
                }
                if (this.videoPreviewUrl) URL.revokeObjectURL(this.videoPreviewUrl);
                this.form.video = file;
                this.videoPreviewUrl = url;
                this.videoMeta = meta;
            },
            // Re-check the video at publish time (platform selection may have changed).
            validateVideo() {
                if (!this.form.video) return true;
                const c = this.videoConstraints;
                if (c.allowedTypes && !c.allowedTypes.includes(this.form.video.type)) {
                    this.failedmsg("Unsupported format", `The video isn't accepted by the selected platforms. Allowed: ${this.videoFormatsLabel}.`);
                    return false;
                }
                if (this.form.video.size > c.maxSizeMB * 1024 * 1024) {
                    this.failedmsg("Video too large", `The video exceeds the ${this.sizeLabel(c.maxSizeMB)} limit for the selected platforms.`);
                    return false;
                }
                const reason = this.checkVideoMeta(this.videoMeta || {}, c);
                if (reason) {
                    this.failedmsg("Unsupported video", `The video: ${reason}.`);
                    return false;
                }
                return true;
            },
            onVideoSelected(event) {
                if (event.target.files && event.target.files.length) {
                    this.setVideo(event.target.files[0]);
                }
                event.target.value = "";
            },
            onVideoDrop(event) {
                this.videoDragOver = false;
                if (event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length) {
                    this.setVideo(event.dataTransfer.files[0]);
                }
            },
            removeVideo() {
                if (this.videoPreviewUrl) URL.revokeObjectURL(this.videoPreviewUrl);
                this.videoPreviewUrl = null;
                this.form.video = null;
                this.videoMeta = null;
            },

            formatBytes(bytes) {
                if (!bytes) return "0 B";
                const units = ["B", "KB", "MB", "GB"];
                const i = Math.floor(Math.log(bytes) / Math.log(1024));
                return (bytes / Math.pow(1024, i)).toFixed(1) + " " + units[i];
            },

            resetForm() {
                this.form.platforms = [];
                this.form.facebook_page_id = "";
                this.form.target_linkedin_page_id = "";
                this.form.title = "";
                this.form.description = "";
                this.form.link_url = "";
                this.form.scheduled_date = "";
                this.photoPreviews.forEach(url => URL.revokeObjectURL(url));
                this.photoPreviews = [];
                this.photoDimensions = [];
                this.form.photos = [];
                this.removeVideo();
            },
        },
        beforeDestroy() {
            this.photoPreviews.forEach(url => URL.revokeObjectURL(url));
            if (this.videoPreviewUrl) URL.revokeObjectURL(this.videoPreviewUrl);
        },
        middleware: "authentication",
    };
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <!-- Profile & connection -->
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="d-flex flex-wrap align-items-center justify-content-between mb-3">
                            <div>
                                <h4 class="card-title mb-0">Profile &amp; Accounts</h4>
                                <span class="text-muted font-size-13">{{ profile.username || username || "—" }}</span>
                            </div>
                            <div class="d-flex align-items-center gap-2">
                                <a href="javascript:void(0);" class="text-primary" title="Refresh" @click="loadProfile(); loadSocialAccounts();">
                                    <i class="mdi mdi-refresh font-size-18"></i>
                                </a>
                                <button
                                    class="btn btn-outline-primary btn-sm"
                                    :disabled="isConnecting"
                                    @click="connectAccounts"
                                >
                                    <span v-if="!isConnecting"><i class="mdi mdi-link-variant me-1"></i>Connect / Manage accounts</span>
                                    <span v-else>Generating link...</span>
                                </button>
                                <router-link to="/content/social_create_post" class="btn btn-success btn-sm">
                                    <i class="mdi mdi-plus me-1"></i>Create a post
                                </router-link>
                            </div>
                        </div>

                        <div v-if="profileError" class="alert alert-warning py-2 mb-3">
                            {{ profileError }}
                        </div>

                        <!-- Cross-check: our stored accounts vs. upload-post's -->
                        <div v-if="accountMismatches.length" class="alert alert-danger py-2 mb-3">
                            <div class="fw-semibold mb-1">
                                <i class="mdi mdi-alert-circle-outline me-1"></i>Connected accounts don't match Upload-Post
                            </div>
                            <ul class="mb-1 ps-3">
                                <li v-for="(msg, i) in accountMismatches" :key="i">{{ msg }}</li>
                            </ul>
                            <div class="font-size-12">
                                Re-sync by using <strong>Connect / Manage accounts</strong> above.
                            </div>
                        </div>

                        <div v-if="loadingSocialAccounts" class="text-muted py-2">
                            <b-spinner small class="me-2"></b-spinner>Loading accounts...
                        </div>
                        <div v-else class="d-flex flex-wrap gap-2">
                            <div
                                v-for="p in availablePlatforms"
                                :key="p.key"
                                class="account-tile"
                                :class="{ 'account-tile--off': !p.connected }"
                            >
                                <div class="account-avatar me-2">
                                    <img v-if="p.account && p.account.social_images" :src="p.account.social_images" alt="" />
                                    <i v-else :class="p.icon"></i>
                                </div>
                                <div class="min-w-0">
                                    <div class="fw-semibold text-truncate"><i :class="p.icon" class="me-1"></i>{{ p.label }}</div>
                                    <div v-if="p.account" class="text-muted font-size-12 text-truncate">
                                        {{ p.account.display_name }}<span v-if="p.account.handle"> · {{ p.account.handle }}</span>
                                    </div>
                                    <div v-else class="text-muted font-size-12">Not connected</div>
                                </div>
                                <i v-if="p.connected" class="mdi mdi-check-circle text-success ms-2"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Analytics metric boxes -->
        <div class="row">
            <div class="col-md-6 col-xl-3">
                <div class="card">
                    <div class="card-body">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <span class="text-muted" style="font-size: 1rem;">Total impressions</span>
                            <div
                                class="d-flex justify-content-center align-items-center"
                                style="width: 36px; height: 36px; border-radius: 12px; background-color: #e6f0ff;"
                            >
                                <i class="mdi mdi-eye-outline" style="color: #3b82f6; font-size: 1.25rem;"></i>
                            </div>
                        </div>

                        <!-- Loader shown while fetching -->
                        <div v-if="loadingImpressions" class="d-flex align-items-center" style="height: 38px;">
                            <b-spinner small class="text-primary"></b-spinner>
                        </div>
                        <template v-else>
                            <div class="mb-1">
                                <h4 class="mb-0" style="font-weight: 400;">
                                    <span data-plugin="counterup">
                                        <countTo
                                            :startVal="0"
                                            :endVal="impressions || 0"
                                            :duration="2000"
                                        ></countTo>
                                    </span>
                                </h4>
                            </div>
                            <p v-if="impressionsError" class="mt-2 mb-0 text-danger" style="font-size: 0.9rem;">
                                {{ impressionsError }}
                            </p>
                            <p v-else-if="impressionsRange" class="mt-2 mb-0 text-muted" style="font-size: 0.9rem;">
                                {{ impressionsRange }}
                            </p>
                        </template>
                    </div>
                </div>
            </div>

            <!-- Total reach -->
            <div class="col-md-6 col-xl-3">
                <div class="card">
                    <div class="card-body">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <span class="text-muted" style="font-size: 1rem;">Total reach</span>
                            <div
                                class="d-flex justify-content-center align-items-center"
                                style="width: 36px; height: 36px; border-radius: 12px; background-color: #e6fff2;"
                            >
                                <i class="mdi mdi-bullseye-arrow" style="color: #22c55e; font-size: 1.25rem;"></i>
                            </div>
                        </div>
                        <div v-if="loadingAnalytics" class="d-flex align-items-center" style="height: 38px;">
                            <b-spinner small class="text-primary"></b-spinner>
                        </div>
                        <template v-else>
                            <div class="mb-1">
                                <h4 class="mb-0" style="font-weight: 400;">
                                    <span data-plugin="counterup">
                                        <countTo :startVal="0" :endVal="totalReach" :duration="2000"></countTo>
                                    </span>
                                </h4>
                            </div>
                            <p v-if="analyticsError" class="mt-2 mb-0 text-danger" style="font-size: 0.9rem;">
                                {{ analyticsError }}
                            </p>
                            <p v-else class="mt-2 mb-0 text-muted" style="font-size: 0.9rem;">
                                Across connected platforms
                            </p>
                        </template>
                    </div>
                </div>
            </div>

            <!-- Gained followers -->
            <div class="col-md-6 col-xl-3">
                <div class="card">
                    <div class="card-body">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <span class="text-muted" style="font-size: 1rem;">Gained followers</span>
                            <div
                                class="d-flex justify-content-center align-items-center"
                                style="width: 36px; height: 36px; border-radius: 12px; background-color: #f3e8ff;"
                            >
                                <i class="mdi mdi-account-plus-outline" style="color: #a855f7; font-size: 1.25rem;"></i>
                            </div>
                        </div>
                        <div v-if="loadingAnalytics" class="d-flex align-items-center" style="height: 38px;">
                            <b-spinner small class="text-primary"></b-spinner>
                        </div>
                        <template v-else>
                            <div class="mb-1">
                                <h4 class="mb-0" style="font-weight: 400;">
                                    <span data-plugin="counterup">
                                        <countTo :startVal="0" :endVal="gainedFollowers" :duration="2000"></countTo>
                                    </span>
                                </h4>
                            </div>
                            <p v-if="analyticsError" class="mt-2 mb-0 text-danger" style="font-size: 0.9rem;">
                                {{ analyticsError }}
                            </p>
                            <p v-else class="mt-2 mb-0 text-muted" style="font-size: 0.9rem;">
                                Across connected platforms
                            </p>
                        </template>
                    </div>
                </div>
            </div>

            <!-- Engagements -->
            <div class="col-md-6 col-xl-3">
                <div class="card">
                    <div class="card-body">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <span class="text-muted" style="font-size: 1rem;">Engagements</span>
                            <div
                                class="d-flex justify-content-center align-items-center"
                                style="width: 36px; height: 36px; border-radius: 12px; background-color: #fff0e6;"
                            >
                                <i class="mdi mdi-thumb-up-outline" style="color: #f97316; font-size: 1.25rem;"></i>
                            </div>
                        </div>
                        <div v-if="loadingAnalytics" class="d-flex align-items-center" style="height: 38px;">
                            <b-spinner small class="text-primary"></b-spinner>
                        </div>
                        <template v-else>
                            <div class="mb-1">
                                <h4 class="mb-0" style="font-weight: 400;">
                                    <span data-plugin="counterup">
                                        <countTo :startVal="0" :endVal="totalEngagements" :duration="2000"></countTo>
                                    </span>
                                </h4>
                            </div>
                            <p v-if="analyticsError" class="mt-2 mb-0 text-danger" style="font-size: 0.9rem;">
                                {{ analyticsError }}
                            </p>
                            <p v-else class="mt-2 mb-0 text-muted" style="font-size: 0.9rem;">
                                Likes, comments &amp; shares
                            </p>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <!-- Post history (Campaigns) -->
                <div class="card">
                    <div class="card-body">
                        <div class="d-flex flex-wrap align-items-center justify-content-between mb-3">
                            <h4 class="card-title mb-0">Campaigns</h4>
                            <div class="d-flex align-items-center flex-wrap gap-2">
                                <div class="search-box">
                                    <i class="mdi mdi-magnify search-icon"></i>
                                    <input
                                        v-model="historySearch"
                                        type="search"
                                        class="form-control"
                                        placeholder="Search posts..."
                                    />
                                </div>
                                <div class="btn-group btn-group-sm status-tabs" role="group">
                                    <button
                                        v-for="s in statusFilters"
                                        :key="s"
                                        type="button"
                                        class="btn"
                                        :class="statusFilter === s ? 'btn-primary' : 'btn-light'"
                                        @click="statusFilter = s"
                                    >{{ s }}</button>
                                </div>
                                <a href="javascript:void(0);" class="text-primary ms-1" title="Refresh" @click="loadHistory">
                                    <i class="mdi mdi-refresh font-size-18"></i>
                                </a>
                            </div>
                        </div>

                        <b-table
                            :busy="loadingHistory"
                            :items="filteredHistory"
                            :fields="historyFields"
                            :per-page="historyPerPage"
                            :current-page="historyCurrentPage"
                            responsive="sm"
                            hover
                            show-empty
                            empty-text="No posts yet"
                            table-class="table align-middle mb-0 campaigns-table"
                            @row-clicked="viewPostDetails"
                        >
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong class="ms-2">Loading...</strong>
                                </div>
                            </template>

                            <template v-slot:cell(post)="data">
                                <div class="fw-semibold text-truncate post-cell">{{ data.item.content || "—" }}</div>
                                <small v-if="data.item.description" class="text-muted d-block text-truncate post-cell">{{ data.item.description }}</small>
                            </template>

                            <template v-slot:cell(platforms)="data">
                                <div class="d-flex">
                                    <span
                                        v-for="key in (data.item.platforms || [])"
                                        :key="key"
                                        class="platform-dot"
                                        :style="{ backgroundColor: platformMeta(key).color }"
                                        :title="key"
                                    ><i :class="platformMeta(key).icon"></i></span>
                                </div>
                            </template>

                            <template v-slot:cell(engagement)="data">
                                <span>{{ postEngagement(data.item) }}</span>
                            </template>

                            <template v-slot:cell(created)="data">
                                <div><i class="mdi mdi-calendar-blank-outline text-muted me-1"></i>{{ dateParts(data.item.timestamp).date || "—" }}</div>
                                <div v-if="dateParts(data.item.timestamp).time" class="text-muted"><i class="mdi mdi-clock-outline me-1"></i>{{ dateParts(data.item.timestamp).time }}</div>
                            </template>

                            <template v-slot:cell(scheduled)="data">
                                <template v-if="data.item.scheduled_date">
                                    <div><i class="mdi mdi-calendar-blank-outline text-muted me-1"></i>{{ dateParts(data.item.scheduled_date).date }}</div>
                                    <div v-if="dateParts(data.item.scheduled_date).time" class="text-muted"><i class="mdi mdi-clock-outline me-1"></i>{{ dateParts(data.item.scheduled_date).time }}</div>
                                </template>
                                <span v-else class="text-muted">—</span>
                            </template>

                            <template v-slot:cell(status)="data">
                                <span class="status-pill" :class="`status-pill--${statusMeta(data.item).variant}`">
                                    <span class="status-dot"></span>{{ statusMeta(data.item).label }}
                                </span>
                            </template>
                        </b-table>

                        <div class="d-flex align-items-center justify-content-between mt-3">
                            <span class="text-muted font-size-13">{{ filteredHistory.length }} of {{ history.length }} posts</span>
                            <b-pagination
                                v-if="filteredHistory.length > historyPerPage"
                                v-model="historyCurrentPage"
                                :total-rows="filteredHistory.length"
                                :per-page="historyPerPage"
                                class="mb-0"
                            ></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <modalViewPostDetails :historyItem="selectedHistoryItem"></modalViewPostDetails>
    </Layout>
</template>

<style scoped>
    /* Campaigns table header controls */
    .search-box {
        position: relative;
    }
    .search-box .search-icon {
        position: absolute;
        top: 50%;
        left: 10px;
        transform: translateY(-50%);
        color: #74788d;
    }
    .search-box .form-control {
        padding-left: 30px;
        min-width: 220px;
        border-radius: 0.5rem;
    }
    .status-tabs .btn {
        border-radius: 0.5rem;
    }

    /* Platform initial dots */
    .platform-dot {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        color: #fff;
        font-size: 15px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border: 2px solid #fff;
        margin-left: -6px;
    }
    .platform-dot:first-child {
        margin-left: 0;
    }

    /* Status pills */
    .status-pill {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        font-size: 0.8125rem;
        font-weight: 500;
        padding: 0.25rem 0.6rem;
        border-radius: 999px;
    }
    .status-pill .status-dot {
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: currentColor;
    }
    .status-pill--success { color: #34c38f; background: rgba(52, 195, 143, 0.12); }
    .status-pill--info { color: #50a5f1; background: rgba(80, 165, 241, 0.12); }
    .status-pill--warning { color: #f1b44c; background: rgba(241, 180, 76, 0.12); }
    .status-pill--danger { color: #f46a6a; background: rgba(244, 106, 106, 0.12); }
    .status-pill--partial { color: #fd7e14; background: rgba(253, 126, 20, 0.12); }
    .status-pill--secondary { color: #74788d; background: rgba(116, 120, 141, 0.12); }

    /* Campaigns table */
    .campaigns-table /deep/ thead th {
        text-transform: uppercase;
        font-size: 0.72rem;
        letter-spacing: 0.04em;
        color: #74788d;
        font-weight: 600;
        border-top: 0;
    }
    .campaigns-table /deep/ tbody tr {
        cursor: pointer;
    }
    .post-cell {
        max-width: 360px;
    }

    /* Connected account tiles */
    .account-tile {
        display: flex;
        align-items: center;
        border: 1px solid #eff2f7;
        border-radius: 0.5rem;
        padding: 0.5rem 0.85rem;
        min-width: 220px;
        background: #fff;
    }
    .account-tile--off {
        opacity: 0.55;
    }
    .min-w-0 {
        min-width: 0;
    }

    .composer-header {
        cursor: pointer;
        user-select: none;
    }
    .account-avatar {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        overflow: hidden;
        flex: 0 0 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f3f5ff;
        color: #556ee6;
        font-size: 18px;
    }
    .account-avatar img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }
    .font-size-11 {
        font-size: 11px;
    }
    .composer-header .mdi {
        font-size: 1.5rem;
        color: #74788d;
    }

    .upload-zone {
        border: 2px dashed #ced4da;
        border-radius: 0.75rem;
        padding: 2.5rem 1.5rem;
        text-align: center;
        cursor: pointer;
        background: #f8f9fc;
        transition: border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
    }
    .upload-zone:hover {
        border-color: #556ee6;
        background: #f3f5ff;
    }
    .upload-zone--active {
        border-color: #556ee6;
        background: #eef1ff;
        box-shadow: 0 0 0 4px rgba(85, 110, 230, 0.12);
    }
    .upload-zone__icon {
        font-size: 2.75rem;
        line-height: 1;
        color: #556ee6;
        margin-bottom: 0.5rem;
    }
    .upload-zone__title {
        font-weight: 600;
        color: #495057;
    }
    .upload-zone__hint {
        font-size: 0.8125rem;
        color: #74788d;
        margin-top: 0.25rem;
    }

    .upload-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
        gap: 0.75rem;
    }
    .upload-thumb {
        position: relative;
        border-radius: 0.5rem;
        overflow: hidden;
        aspect-ratio: 1 / 1;
        background: #000;
        box-shadow: 0 1px 4px rgba(18, 38, 63, 0.12);
    }
    .upload-thumb img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }
    .upload-thumb__remove {
        position: absolute;
        top: 6px;
        right: 6px;
        width: 24px;
        height: 24px;
        border: none;
        border-radius: 50%;
        background: rgba(0, 0, 0, 0.55);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1;
        cursor: pointer;
        transition: background 0.15s ease;
    }
    .upload-thumb__remove:hover {
        background: #f46a6a;
    }
    .upload-thumb__meta {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 2px 6px;
        font-size: 0.7rem;
        color: #fff;
        background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
    }

    .upload-video-card {
        display: flex;
        gap: 1rem;
        padding: 0.75rem;
        border: 1px solid #eff2f7;
        border-radius: 0.75rem;
        background: #fff;
        box-shadow: 0 1px 4px rgba(18, 38, 63, 0.08);
    }
    .upload-video-card__player {
        width: 220px;
        max-width: 45%;
        border-radius: 0.5rem;
        background: #000;
    }
    .upload-video-card__info {
        flex: 1;
        min-width: 0;
    }
    .upload-video-card__name {
        font-weight: 600;
        color: #495057;
    }
    .upload-video-card__meta {
        font-size: 0.8125rem;
        color: #74788d;
    }
</style>
